import { Link } from 'react-router'
import { AgreementStatusBadge } from './AgreementStatusBadge'
import { agreementHref, followUpLine, partyText } from './format'
import type { Agreement } from './types'

/**
 * The phone presentation of Afspraken (ED-50): a card per agreement with its title, state, relation
 * and follow-up line. The title is a stretched link: the whole card is the tap target (≥ 44 px).
 */
export function AgreementCardList({ rows }: { rows: Agreement[] }) {
  return (
    <ul className="flex flex-col gap-2">
      {rows.map((agreement) => (
        <li key={agreement.id} className="vonk-card relative flex flex-col gap-1 p-3">
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to={agreementHref(agreement)}
              className="font-medium text-foreground underline-offset-2 after:absolute after:inset-0 after:content-[''] hover:underline"
            >
              {agreement.title}
            </Link>
            <AgreementStatusBadge agreement={agreement} />
          </div>
          <p className="truncate text-sm text-muted-foreground">{partyText(agreement) || '—'}</p>
          <p className="text-sm text-muted-foreground">{followUpLine(agreement)}</p>
        </li>
      ))}
    </ul>
  )
}
